import { render, staticRenderFns } from "./ValvesExtraItem.vue?vue&type=template&id=45dfdba8&scoped=true"
import script from "./ValvesExtraItem.vue?vue&type=script&lang=js"
export * from "./ValvesExtraItem.vue?vue&type=script&lang=js"
import style0 from "./ValvesExtraItem.vue?vue&type=style&index=0&id=45dfdba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dfdba8",
  null
  
)

export default component.exports